import { DailerMessageE } from '@enums/dialer-message.enum';

export const dialerStatusMessage = [
  {
    name: 'CALLING',
    value: DailerMessageE.CALL,
  },
  {
    name: 'IN_CALL',
    value: DailerMessageE.IN_CALL,
  },
  {
    name: 'CALL_CLOSED',
    value: DailerMessageE.END_CALL,
  },
  {
    name: 'CALL_ENDING',
    value: DailerMessageE.HANGUP,
  },
];
